<!-- 登录页 -->
<template>
  <div class="blindBox">
        <div class="mhBtn">
            <wx-open-launch-weapp class="weapp" id="launch-btn" username="gh_e7f48606d8b3" :path="'/pages/index/index?qrCodeUrl='+ url">
                <script type="text/wxtag-template">
                    <style>
                        .img { width:100%;height:100%;}
                    </style>
                    <img src="https://zhaoxiaopuls.oss-cn-beijing.aliyuncs.com/puls_img/puls_indes/gomh.png" alt="" class="img">
                </script>
            </wx-open-launch-weapp>
        </div>
  </div>
</template>

<script>
import * as api from '@/api'
import JmmToast from '@/components/JmmToast'
import wx from 'weixin-js-sdk'
import '@/assets/stylecss/iconfont.css'
var Base64 = require('js-base64').Base64
export default {
  name: 'login',
  data() {
    return {
      token: 'jjcimpilpgejfeehkdinjlbgabbgchhe',
      sign: '',
      appid: "wxc528cd4698883637",   
      url:''   
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    this.code = this.$route.query.code;
    this.url = this.$route.query.url;
    console.log(this.url)
    console.log(this.code)
    this.fetch(this.code);
    this.getxcx();
  },
  mounted () {
    
  },
  components: { JmmToast },
  methods: {
    async getxcx(){
      let that = this
         const url = encodeURIComponent(location.href.split("#")[0]); //获取当前页面路由
        //  let url = location.href.split('#')[0]
         const res = await api.user.getSign(url)
          // console.log(res, ' === getSign返回')
        if (res.code == '000000') {
          wx.config({
            debug: false, 
            appId: 'wxc528cd4698883637', // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表
            openTagList: ['wx-open-launch-weapp']
          })

            
        }     
    },
     //  code 登录
  async fetch(codeNum) {
    console.log('我是fetch登录')
    try {
      let info = { "appId": this.appid, "wxcode": codeNum}
    
        localStorage.setItem('reToken', this.token)
        const res = await api.user.getwebLogin(info)
        if (res.code == "000000") { 
            this.sign = res.data.sign
            localStorage.setItem('reSESSIONKEY', res.data.SESSIONKEY)
            localStorage.setItem('codeSign', res.data.sign)
        } 
    } catch (err) {
      console.log(err)
    }
  },
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'
.blindBox{
    width 100%;
    height 1492px;
    background: url("https://zhaoxiaopuls.oss-cn-beijing.aliyuncs.com/puls_img/puls_indes/mgBg.png") no-repeat;
    position relative;
    background-size: 100% 100%;
    overflow: hidden;
    .mhBtn{
        width 393px;
        height 110px;
        overflow hidden;
        position: absolute;
        z-index 1;
        top: 1187px;
        left: 50%;
        transform: translateX(-50%);
        .weapp{
            width 393px;
            height 110px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/blindBox/index.vue